import MatchRunComparison from '../../components/MatchRunComparison'

const MatchRunComparisonPage = () => {
  return <MatchRunComparison />
}

export default MatchRunComparisonPage
